import { render, staticRenderFns } from "./Ubuntu20.vue?vue&type=template&id=da953216&scoped=true&"
import script from "./Ubuntu20.vue?vue&type=script&lang=js&"
export * from "./Ubuntu20.vue?vue&type=script&lang=js&"
import style0 from "./Ubuntu20.vue?vue&type=style&index=0&id=da953216&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da953216",
  null
  
)

export default component.exports